import React ,{useState} from "react";
import {useHistory} from "react-router-dom";
import axios from "axios";
import Loader from "./Loader";

function ForgotPassword() {
    let history = useHistory();
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState({
        Email: ""
    });
    const [errorMessage , setErrorMessage] = useState("");

    const handleInputChange = (event) =>{
        event.preventDefault()
        setEmail({[event.target.name]: event.target.value});
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen(!open);
    };
    const validateInput = (element) => {
        let errors = {
            isValidated: true,
            Email: ""
        };
        if(!element.Email) {
            errors.isValidated = false;
            errors.Email = "Input cant't be empty";
        }
        else if(!/\S+@\S+\.\S+/.test(element.Email)){
            errors.isValidated = false;
            errors.Email = "Email not valid";
        }
        return errors;
    }

    const searchEmail = () => {
        if(validateInput(email).isValidated){
            setErrorMessage("");
            handleToggle();
            axios.post(process.env.REACT_APP_BASEURL + process.env.REACT_APP_VALIDATE_EMAIL,email)
                .then((res) =>{
                    handleClose();
                    if(res.data.isSuccess){
                        localStorage.setItem("id", res.data.userId);
                        history.push("/reset-password");
                    }
                    else{
                        setErrorMessage("User does not exist!!!");
                    }
                    
                })
                .catch(err =>{
                    handleClose();
                })
        }
        else{
            setErrorMessage(validateInput(email).Email);
        }
    }
    
    return (
        <div className="service-staff-body">
            <div className="body">
                <div className="password-body-inner-wrapper">
                    <div className="code-verify-wrapper">
                        <div className="header-container">
                            <h2>Enter your email</h2>
                            <hr />
                        </div>
                        <p className="error">{errorMessage}</p>
                        <div className="code-verify-container">
                            <input
                                type= "text"
                                placeholder= "Email"
                                maxLength= "30"
                                className ="code"
                                name= "Email"
                                onChange={handleInputChange}
                            />
                            <button 
                                type="submit" 
                                className="button" 
                                name="submit"
                                onClick={searchEmail}
                                >
                                Submit   
                            </button>
                        </div>
            
                    </div>
                </div>
            </div>
            <Loader state={open} />
        </div>
    )
}

export default ForgotPassword
